<template>
    <fieldset
        class="fieldset"
        aria-describedby="content-info-text"
    >
        <legend
            :id="uniqueId"
            class="legendelement"
        >
            {{ $t(listHeading) }}
        </legend>
        <div class="checkbox-list-element">
            <div
                role="group"
                class="container"
            >
                <div
                    v-for="(item, index) in checkboxListItems"
                    :key="index"
                >
                    <input
                        :id="'checkbox-' + item.checkboxValue + index"
                        type="checkbox"
                        :checked="item.selectionValue"
                        class="item-container"
                        aria-describedby="content-info-text"
                        @change="changeCheckBox(item, $event)"
                    >
                    <label
                        :for="'checkbox-' + item.checkboxValue + index"
                        class="input-label checkbox-input-label"
                    >{{ $t(item.labelText) }}</label>
                </div>
            </div>
        </div>
    </fieldset>
</template>

<script lang="ts">
    import { Vue, Component, Prop } from "vue-facing-decorator"
    import CheckboxModel from "@/models/checkboxmodel"

    @Component
    export default class CheckboxList extends Vue {
        elementData: Array<CheckboxModel> = []
        uniqueId: string = ""
        ticks: number = 0

        @Prop() listHeading: string | undefined
        @Prop({ type: Array, default: [] }) readonly checkboxList!: Array<CheckboxModel>

        created() {
            this.uniqueId = "id-" + Math.random().toString(16).slice(2)
        }

        mounted(): void {
            this.elementData = this.checkboxList
        }

        deactivated() {
            this.checkboxList.forEach(value => {
                value.selectionValue = true
            })
        }

        get checkboxListItems(): CheckboxModel[] {
            return this.elementData
        }

        changeCheckBox(item: CheckboxModel, event): void {
            item.selectionValue = !item.selectionValue
            this.$emit("checkboxItem", item)
            this.setFocusToElement(2, event)
        }

        // sets focus to the selected radio button
        setFocusToElement(ticksToWait, event) {
            if (this.ticks < ticksToWait) {
                this.ticks++
                this.$nextTick(() => {
                    this.setFocusToElement(ticksToWait, event)
                })
            }
            else {
                this.ticks = 0
                if (event) {
                    event.target.focus()
                }
            }
        }
    }
</script>

<style scoped>
    .legendelement {
            font-size: 1.125rem;
            font-family: Montserrat;
    }
    .checkbox-list-element {
        margin-top: 2rem !important;
    }

    .container {
        margin: 0;
        padding: 0;
    }

    .checkbox-div {
        margin-top: .3rem;
    }

    input[type="checkbox"] {
        height: 0px;
        margin-top: .5rem;
    }

        input[type="checkbox"].error {
            filter: invert(34%) sepia(114%) saturate(6707%) hue-rotate(324deg) brightness(79%) contrast(70%);
        }

    label.input-label.checkbox-input-label {
        vertical-align: super;
        width: unset;
    }

    .checkboxelement .error-label {
        position: sticky;
    }
</style>
